import api from '@/api';

const { $student, $pricing, $billing  } = api;

export const { $studentAccount, $students, $exceptions, $billingData} = $student;
export const { $types, $transfer } = $pricing;
export const { $provincias, $localidades, $process } = $billing;
 